import icon from 'vue-svgicon';

icon.register({
    'regular/cash-briefcase': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M9.75 15.937c0 .932 1.007 1.688 2.25 1.688s2.25-.756 2.25-1.688S13.243 14.25 12 14.25s-2.25-.756-2.25-1.688 1.007-1.687 2.25-1.687 2.25.755 2.25 1.687M12 9.75v1.125M12 17.625v1.125" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><rect pid="1" x="1.5" y="6.75" width="21" height="15" rx="1.5" ry="1.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="2" d="M15.342 3.275a1.5 1.5 0 0 0-1.423-1.025h-3.838a1.5 1.5 0 0 0-1.423 1.025L7.5 6.75h9z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
